import React, { useState } from 'react';
import './styles/Timesheet.css';
import ClockIn from './Clockin';
import ClockOut from './Clockout';
import MyTimeLog from './TimeLog'; // 👈 same component
import Availability from './Availability';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Timesheet = () => {
  const today = new Date();
  const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
  const [weekStart, setWeekStart] = useState(startOfWeek);

  const [openDropdown, setOpenDropdown] = useState(null);
  const [ClockInActive, setClockInActive] = useState(false);
  const [ClockOutActive, setClockOutActive] = useState(false);
  const [currentView, setCurrentView] = useState('schedule');

  // 🔹 State to store logs
  const [logs, setLogs] = useState([
    {
      job: 'Residential Cleaning',
      date: 'Sep 22, 2025',
      time: '09:00 AM',
      status: 'Approved',
      type: 'Clock In',
    },
    {
      job: 'Residential Cleaning',
      date: 'Sep 22, 2025',
      time: '01:00 PM',
      status: 'Approved',
      type: 'Clock Out',
    },
    {
      job: 'Kitchen Cleaning',
      date: 'Sep 23, 2025',
      time: '10:00 AM',
      status: 'Pending Approval',
      type: 'Clock In',
    },
    {
      job: 'Office Cleaning',
      date: 'Sep 23, 2025',
      time: '06:00 PM',
      status: 'Correction needed',
      type: 'Clock Out',
    },
  ]);

  // Example tasks (same as before)
  const tasksByDate = {
    '2025-09-23': [{ title: 'Kitchen Cleaning', time: '4:00 PM - 7:00 PM' }],
    '2025-09-24': [
      { title: 'Residential Cleaning', time: '9:00 AM - 1:00 PM' },
    ],
    '2025-09-26': [
      { title: 'Residential Cleaning', time: '9:00 AM - 1:00 PM' },
      { title: 'Restaurants Cleaning', time: '11:00 PM - 1:00 AM' },
    ],
  };

  const getWeekDays = (startDate) => {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);

      const key = date.toISOString().split('T')[0];
      days.push({
        day: date.toLocaleDateString('en-US', { weekday: 'short' }),
        date: date.getDate(),
        fullDate: date.toDateString(),
        tasks: tasksByDate[key] || [],
      });
    }
    return days;
  };

  const days = getWeekDays(weekStart);

  // Navigation
  const handlePrevWeek = () => {
    const newStart = new Date(weekStart);
    newStart.setDate(weekStart.getDate() - 7);
    setWeekStart(newStart);
  };
  const handleNextWeek = () => {
    const newStart = new Date(weekStart);
    newStart.setDate(weekStart.getDate() + 7);
    setWeekStart(newStart);
  };

  // Clock actions
  const addLog = (task, type) => {
    const now = new Date();
    const entry = {
      job: task.title,
      date: now.toDateString(),
      time: now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      status: 'Pending Approval',
      type: type, // "Clock In" or "Clock Out"
    };
    setLogs((prev) => [...prev, entry]);
  };

  const toggleDropdown = (taskIndex) => {
    setOpenDropdown(openDropdown === taskIndex ? null : taskIndex);
  };

  // 🔹 Fix: missing handlers
  const handleCloseClockIn = () => {
    setClockInActive(false);
  };

  const handleCloseClockOut = () => {
    setClockOutActive(false);
  };

  const renderScheduleView = () => (
    <>
      <div className="week-nav">
        <FaChevronLeft className="arrow" onClick={handlePrevWeek} />
        <span className="week-label">
          {days[0].fullDate} - {days[6].fullDate}
        </span>
        <FaChevronRight className="arrow" onClick={handleNextWeek} />
      </div>

      <div className="schedule-sheet">
        {days.map((d, key) => (
          <div key={key} className="day-column">
            <p className="date">
              {d.day} {d.date}
            </p>
            {d.tasks.length > 0 ? (
              d.tasks.map((task, i) => {
                const taskKey = `${key}-${i}`;
                return (
                  <div key={i} className="task-box">
                    <p>{task.title}</p>
                    <p>{task.time}</p>
                    <button className="small-btn">View details</button>
                    <div className="time-log">
                      <button
                        className="dropdown-btn"
                        onClick={() => toggleDropdown(taskKey)}
                      >
                        Time Log ▾
                      </button>
                      {openDropdown === taskKey && (
                        <div className="clock-buttons">
                          <button
                            className="clock-btn"
                            onClick={() => {
                              setClockInActive(true);
                              addLog(task, 'Clock In');
                            }}
                          >
                            Clock In
                          </button>
                          <hr />
                          <button
                            className="clock-btn"
                            onClick={() => {
                              setClockOutActive(true);
                              addLog(task, 'Clock Out');
                            }}
                          >
                            Clock Out
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="no-task">No Task</p>
            )}
          </div>
        ))}
      </div>
    </>
  );

  return (
    <div className="timesheet-container">
      <div className="header-container">
        <h2 className="title">
          {currentView === 'schedule'
            ? 'My Work Schedule'
            : currentView === 'timeLog'
            ? 'My Time Log'
            : 'My availability'}
        </h2>
        <div
          className="buttons-container"
          style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
        >
          <button
            className={`btn my-schedule-btn ${
              currentView === 'schedule' ? 'active' : ''
            }`}
            onClick={() => setCurrentView('schedule')}
          >
            My Work Schedule
          </button>
          <button
            className={`btn my-time-log-btn ${
              currentView === 'timeLog' ? 'active' : ''
            }`}
            onClick={() => setCurrentView('timeLog')}
          >
            My Time Log
          </button>
          <button
            className={`btn my-availability-btn ${
              currentView === 'availability' ? 'active' : ''
            }`}
            onClick={() => setCurrentView('availability')}
          >
            My availability
          </button>
        </div>
      </div>
  
      {currentView === "schedule" && renderScheduleView()}
      {currentView === "timeLog" && <MyTimeLog logs={logs} />}
      {currentView === "availability" && <Availability />} 
      
      {ClockInActive && <ClockIn onClose={handleCloseClockIn} />}
      {ClockOutActive && <ClockOut onClose={handleCloseClockOut} />}
    </div>
  );
};

export default Timesheet;
